import { useState, useMemo, useEffect, useCallback } from 'react'
import { useWireState, useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { formatCurrency } from '@utils'
import { toast } from 'react-toastify'
import cn from 'clsx'

import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { MdOutlineStarOutline, MdOutlineStar } from 'react-icons/md'

const CurrentOrgProjectSelectorDialog = ({
    className,
}) => {
    
    const [selectedOrg, setSelectedOrg] = useState(null)
    // const [selectedProject, setSelectedProject] = useState(null)
    
    const [open, setOpen] = useWireState(store.currentOrgProjectSelectorDialogOpen)
    const user = useWireValue(store.user)
    const [currentOrganization, setCurrentOrganization] = useWireState(store.currentOrganization)
    
    const orgs = useMemo(() => (
        (user?.organizations || [])
            .sort((a, b) => a.name.localeCompare(b.name))
            .sort((a, b) => {
                
                if (a.UserOrganizationJoin.isStarred && !b.UserOrganizationJoin.isStarred) return -1
                if (!a.UserOrganizationJoin.isStarred && b.UserOrganizationJoin.isStarred) return 1
                
                return 0
                
            })
    ), [user])
    
    const closeDialog = () => {
        
        setSelectedOrg(null)
        // setSelectedProject(null)
        
        setOpen(false)
        
    }
    
    const updateCurrentGlobals = useCallback(() => {
        
        setCurrentOrganization(selectedOrg)
        // setCurrentProject(selectedProject)
        
        closeDialog()
        
    }, [selectedOrg])
    
    const updateOrgIsStarred = useCallback(async (id, isStarred) => {
        
        try {
            await actions.setOrganizationStarred(id, isStarred)
        } catch (e) {
            console.log(e)
            toast.error('Failed to star organization')
        }
        
    }, [])
    
    useEffect(() => {
        
        if (!selectedOrg && currentOrganization)
            setSelectedOrg(currentOrganization)
        
    }, [selectedOrg, currentOrganization])
    
    return (
        
        <CustomModal
            className={cn('CurrentOrgProjectSelectorDialog !min-w-[30rem] !max-w-[25vw]', className)}
            open={open}
            modalHandler={() => setOpen(false)}
            center>
            
            <div className="modal-body px-2">
                
                <div className="mt-5">
                    <h3 className="text-xl">Current Organization</h3>
                    <p>
                        By setting a &quot;current&quot; organization, all projects, collections,
                        documents, etc. shown will only be from that organization.
                    </p>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th>Organization</th>
                                <th>Balance</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {orgs.map(it => (
                                <tr key={it.id}>
                                    <td>
                                        <a
                                            className={cn('flex justify-between items-center gap-20',
                                                'cursor-pointer text-end', {
                                                    'text-accent': it.id === selectedOrg?.id,
                                                },
                                            )}
                                            onClick={e => {
                                                e.preventDefault()
                                                setSelectedOrg(it)
                                            }}>
                                            {it.name}
                                        </a>
                                    </td>
                                    <td>{formatCurrency(it.credits || 0)}</td>
                                    <td className="w-10">
                                        <button
                                            className="btn btn-sm btn-square btn-ghost opacity-70 hover:opacity-100"
                                            onClick={() => updateOrgIsStarred(
                                                it.id, !it.UserOrganizationJoin.isStarred)}>
                                            {it.UserOrganizationJoin.isStarred
                                                ? <MdOutlineStar className="text-xl text-base-content" />
                                                : <MdOutlineStarOutline
                                                    className="text-xl text-base-content opacity-50" />}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                
                {/* @todo don't delete, will add projects to selector */}
                {/* <div className="mt-5">
                    <h3 className="text-2xl">Current Project</h3>
                    <ul className="flex flex-wrap gap-2 mt-3">
                        {user?.project?.map(it => (
                            <li key={it.id}>
                                <a
                                    className={cn('btn', {
                                        'btn-primary': it.id === selectedOrg?.id,
                                    })}
                                    onClick={() => setSelectedProject(it)}>
                                    {it.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div> */}
            
            </div>
            
            <div className="flex justify-end modal-footer mt-5">
                <button
                    className="mr-3 btn btn-primary btn-outline"
                    onClick={closeDialog}>
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    onClick={updateCurrentGlobals}>
                    Update
                </button>
            </div>
        
        </CustomModal>
        
    )
    
}

export default CurrentOrgProjectSelectorDialog
